module.exports = "/images/vendor/vue2vis/dist/downArrow.png?bbfbf2e8eaa8ebbce8524769ac0a5bc0";